module.exports = __webpack_public_path__ + "media/solarPlusMirror.45b57966.mp4";